import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import App from './App';
import store from './redux/store.js';
import { BrowserRouter} from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import FarmasisTheme from './muiThemes/Theme.js'
import { register } from './serviceWorker.js';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  
    <React.StrictMode>
    <BrowserRouter>
    <Provider store={store}>
    <ThemeProvider theme={FarmasisTheme}>
    <App />
    </ThemeProvider>
    </Provider>
    </BrowserRouter>
    </React.StrictMode>
);

register();
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

